"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var UserConfig = /** @class */ (function () {
    function UserConfig(BASE_URL, FUNCTIONS_KEY) {
        this.axios = axios_1.default.create({
            baseURL: BASE_URL
        });
        this.axios.defaults.headers.common["x-functions-key"] = FUNCTIONS_KEY;
        // Interceptors
        // this.axios.interceptors.request.use((config: AxiosRequestConfig) => {
        // return config;
        // });
        // Interceptors
        this.axios.interceptors.request.use(function (config) {
            var _a;
            config.headers = ((_a = config.headers) !== null && _a !== void 0 ? _a : {});
            var tokenString = localStorage.getItem('token');
            if (tokenString != null) {
                var token = JSON.parse(tokenString);
                config.headers.set("Authorization", "Bearer ".concat(token));
            }
            return config;
        });
        ////////
        this.axios.interceptors.response.use(function (res) {
            return res.data;
        }, function (err) {
            var code = err.response && err.response.status;
            if (code === 401)
                console.log("Usuario No Autorizado");
            if (code === 403)
                console.log("Usuario No Autorizado");
            if ((code + '').startsWith('5')) {
                console.log(err);
            }
            return Promise.reject(err);
        });
    }
    return UserConfig;
}());
exports.default = UserConfig;
